export const MOBILE_WEB = 'mobile_web';
export const WEB = 'web';
